import React from 'react'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'

const IntlMessage = ({ id, fallback, children }) => {
  const { t } = useTranslation()

  const translate = t(id || children || fallback, children || fallback)

  return <>{translate}</>
}

/**
 * 주어진 번역 키(id)에 대한 번역된 문자열을 반환하고, 필요한 경우 추가 인자들을 사용하여 문자열 내의 위치 표시자를 치환합니다.
 * @param {string} id 번역 키
 * @param  {...any} values 치환할 값들 (가변 인자)
 * @returns {string} 번역된 문자열
 */
export const translate = (id, ...values) => {
  let translation = i18n.t(id)

  // 문자열 내의 {0}, {1}, {2}, ... 를 values 배열의 해당 값으로 치환
  values.forEach((value, index) => {
    translation = translation.replace(new RegExp(`\\{${index}\\}`, 'g'), value)
  })

  return translation
}

export default IntlMessage
